import { useEffect, useState } from 'react';

import { useBoundStore } from 'app/store';
import { OneBtnFooter } from 'widgets/HsptlzForm/ui';

import { convertToPdfRequest, generateAllPages } from '../lib/htmlDataBinder';
import { useGetPayDetailStatementItem, usePdfDownload, usePostPayDetailPdfDownload } from '../model';

import BillLogo from './bill-logo.png';
import './detail.css';

const calcTableScale = (n) => {
  const a = 0.0011078;
  const b = 0.003;
  const scale = a * n + b;
  return parseFloat(scale.toFixed(3));
};

export const Detail = () => {
  const serviceParams = useBoundStore((state) => state['medicalReceipt'].serviceParams);
  const [isDownloading, setIsDownloading] = useState(false);

  const { data } = useGetPayDetailStatementItem({
    hspId: serviceParams.hspId,
    mpiKey: serviceParams.mpiKey,
    receivePaymentId: serviceParams.receivePaymentId,
    medicalInsuranceType: serviceParams.medicalInsuranceType,
  });

  const { mutate: downloadPdf } = usePostPayDetailPdfDownload();
  const { downloadPdf: downloadPdfByFileId } = usePdfDownload();

  const detailData = data;

  const singleHtml = generateAllPages(detailData, 25);

  const handleDownload = () => {
    if (isDownloading) return;

    setIsDownloading(true);
    const pdfRequest = convertToPdfRequest(singleHtml);

    downloadPdf(pdfRequest, {
      onSuccess: (response) => {
        const fileId = response.data.fileId;
        downloadPdfByFileId(fileId);
      },
      onError: (error) => {
        console.error('PDF 다운로드 중 오류 발생:', error);
      },
      onSettled: () => {
        setIsDownloading(false);
      },
    });
  };

  const displayPages = [];
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = singleHtml;

  // detail-table-wrap 요소들을 찾아서 페이지별로 분할
  const tableWraps = tempDiv.querySelectorAll('.detail-table-wrap');
  tableWraps.forEach((wrap, index) => {
    displayPages.push(wrap.outerHTML);
  });

  useEffect(() => {
    const tableWrap = document.querySelectorAll('.detail-bills');
    const tPaddingBottom = 10;

    tableWrap.forEach((el) => {
      const twWidht = el.getBoundingClientRect().width;
      const tScale = calcTableScale(twWidht);

      if (el instanceof HTMLElement && tScale <= 1) {
        const table = el.children[0];
        table.style.transform = `scale(${tScale})`;
        const tHeight = table.getBoundingClientRect().height;
        el.style.height = `${tHeight + tPaddingBottom}px`;
      }
    });
  }, []);

  return (
    <div className='container-wrap receipt-detail-container'>
      <div className='top-box'>
        <div className='title-wrap'>
          <h2>진료비 세부내역서</h2>
          <p className='desc'>세부내역서를 내려 보거나 다운로드할 수 있어요.</p>
        </div>
        <button type='button' className='down-btn' onClick={handleDownload} disabled={isDownloading}>
          <img src={BillLogo} width={24} height={24} />
          <p>세부내역서 다운로드</p>
        </button>
      </div>

      <div className='detail-body'>
        <div>
          {displayPages.map((pageHtml, index) => (
            <div key={index} className='detail-bills' dangerouslySetInnerHTML={{ __html: pageHtml }} />
          ))}
        </div>
      </div>

      <OneBtnFooter
        text={'돌아가기'}
        isValid
        btnType='secondary'
        handleClick={() => {
          window.location.href = serviceParams.redirectUrl;
        }}
      />
    </div>
  );
};
